// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"106":"a3875988c35fa08f","255":"6a5fce98c577fa6c","620":"b77cfcde3a4831c0","709":"6eb1dbd672be91af"}[chunkId] + ".js";
};